export default __webpack_public_path__ + "static/ringblank-d388a3f7cfcdf5adccb587b6b28c6f7a.png";